import { render, staticRenderFns } from "./KriterOnayFormu.vue?vue&type=template&id=0211ac47&scoped=true"
import script from "./KriterOnayFormu.vue?vue&type=script&lang=js"
export * from "./KriterOnayFormu.vue?vue&type=script&lang=js"
import style0 from "./KriterOnayFormu.vue?vue&type=style&index=0&id=0211ac47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0211ac47",
  null
  
)

export default component.exports